import * as api from "../../api/customLoginForm";
import { log2 } from "../../utils/log2";
import { toObject } from "../../utils/languageContent";

const log = log2("customLoginForm.vuex");
const customLoginForm = {
    namespaced: true,
    state: {
        inputs: [],
    },
    mutations: {
        SET_ALL_INPUTS: (state, inputs) => {
            log.debug("SET_ALL_INPUTS", inputs);
            state.inputs = inputs.map((x) => toObject(x, "localizedLabel"));
        },
    },
    actions: {
        getCustomLoginFormInputs({ commit }) {
            return api.getCustomLoginFormInputs().then((response) => {
                const inputs = response.data;
                commit("SET_ALL_INPUTS", inputs || []);
            });
        },
        multiSetInputs({ commit, rootState }, inputs) {
            log("multiSetInputs called", inputs);
            commit("SET_ALL_INPUTS", inputs);
        },
    },
};

export default customLoginForm;



// WEBPACK FOOTER //
// ./src/store/modules/customLoginForm.js